import { render, staticRenderFns } from "./RootsAndDegreesPreview.vue?vue&type=template&id=1d7338b4&lang=pug&"
import script from "./RootsAndDegreesPreview.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegreesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports